"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.everCovidDiseaseMessages = exports.EverCovidDisease = void 0;
const schema_1 = require("../../../../../schema");
var EverCovidDisease;
(function (EverCovidDisease) {
    EverCovidDisease["YES"] = "YES";
    EverCovidDisease["NO"] = "NO";
    EverCovidDisease["UNKNOWN"] = "UNKNOWN";
})(EverCovidDisease || (exports.EverCovidDisease = EverCovidDisease = {}));
exports.everCovidDiseaseMessages = {
    [EverCovidDisease.YES]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidDisease.everCovidDisease.YES",
        defaultMessage: "Igen"
    },
    [EverCovidDisease.NO]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidDisease.everCovidDisease.NO",
        defaultMessage: "Nem"
    },
    [EverCovidDisease.UNKNOWN]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidDisease.everCovidDisease.UNKNOWN",
        defaultMessage: "Nem ismert"
    }
};
const everCovidDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(EverCovidDisease.YES),
    schema_1.Schema.singleChoiceItem(EverCovidDisease.NO),
    schema_1.Schema.singleChoiceItem(EverCovidDisease.UNKNOWN)
]);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ everCovidDisease })
    .interpretation({ vocab: "ktx", code: "covid_disease" });
